import { render, staticRenderFns } from "./ShowCurrentDiscussion.vue?vue&type=template&id=5403cb21&scoped=true&"
import script from "./ShowCurrentDiscussion.vue?vue&type=script&lang=js&"
export * from "./ShowCurrentDiscussion.vue?vue&type=script&lang=js&"
import style0 from "./ShowCurrentDiscussion.vue?vue&type=style&index=0&id=5403cb21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5403cb21",
  null
  
)

export default component.exports